import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Splash screen component shown while the backend is waking up.
 * Displays the DibsOnDance logo centered with a spinner animation.
 */
@Component({
  selector: 'app-splash-screen',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="splash-container">
      <div class="splash-content">
        <img
          src="/logo/logo_full.svg"
          alt="DibsOnDance"
          class="splash-logo"
        />
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
        @if (error()) {
          <p class="error-message">{{ error() }}</p>
        }
      </div>
    </div>
  `,
  styles: [`
    .splash-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f4;
      z-index: 9999;
    }

    .splash-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
    }

    .splash-logo {
      width: 280px;
      height: auto;
      animation: fadeIn 0.5s ease-out;
    }

    .spinner-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .spinner {
      width: 40px;
      height: 40px;
      border: 3px solid rgba(156, 163, 175, 0.3);
      border-top-color: #9ca3af;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    .error-message {
      color: #374151;
      font-size: 0.875rem;
      text-align: center;
      max-width: 300px;
      padding: 0.75rem 1rem;
      background: rgba(0, 0, 0, 0.05);
      border-radius: 0.5rem;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `],
})
export class SplashScreenComponent {
  /** Optional error message to display */
  error = input<string | null>(null);
}
